/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Payment_Mark_All_PaidInputs */



/**
* | output |
* | --- |
* | "Mark All Paid" |
*
* @param {Payment_Mark_All_PaidInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const payment_mark_all_paid = /** @type {((inputs?: Payment_Mark_All_PaidInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Payment_Mark_All_PaidInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Tout marquer payé")
	if (locale === "es") return /** @type {LocalizedString} */ ("Marcar todo pagado")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Marcar todos como pagos")
	if (locale === "it") return /** @type {LocalizedString} */ ("Segna tutti pagati")
	return /** @type {LocalizedString} */ ("Mark All Paid")
});